import * as Types from 'src/actions/juridical-person/index/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import IndexResponse from 'src/value-objects/IndexResponse';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetIndexJuridicalPersonsAttempt extends Action {
  type: Types.GET_INDEX_JURIDICAL_PERSONS_ATTEMPT;
}

export interface GetIndexJuridicalPersonsSuccess extends Action {
  type: Types.GET_INDEX_JURIDICAL_PERSONS_SUCCESS;
  payload: JuridicalPerson[];
}

export interface GetIndexJuridicalPersonsFailure extends Action {
  type: Types.GET_INDEX_JURIDICAL_PERSONS_FAILURE;
  payload: {};
}

export type GetIndexJuridicalPersonsAction =
  GetIndexJuridicalPersonsAttempt
  | GetIndexJuridicalPersonsSuccess
  | GetIndexJuridicalPersonsFailure;

export interface GetIndexJuridicalPersonsThunk
  extends ThunkAction<Promise<GetIndexJuridicalPersonsAction>, RootState, string> {
}

export const getIndexJuridicalPersonsAttempt: ActionCreator<GetIndexJuridicalPersonsAttempt> = () => (
  {
    type: Types.GET_INDEX_JURIDICAL_PERSONS_ATTEMPT
  }
);

export const getIndexJuridicalPersonsSuccess: ActionCreator<GetIndexJuridicalPersonsSuccess> = (
  juridicalPersons: JuridicalPerson[]
) => ({
  type: Types.GET_INDEX_JURIDICAL_PERSONS_SUCCESS,
  payload: juridicalPersons
});

export const getIndexJuridicalPersonsFailure: ActionCreator<GetIndexJuridicalPersonsFailure> = (error: {}) => ({
  type: Types.GET_INDEX_JURIDICAL_PERSONS_FAILURE,
  payload: error
});

export const getIndexJuridicalPersons: ActionCreator<GetIndexJuridicalPersonsThunk> =
  (id: string): GetIndexJuridicalPersonsThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetIndexJuridicalPersonsAction> => {
      dispatch(getIndexJuridicalPersonsAttempt());

      return ApiClient.userJuridicalPersons.index({userId: id})
        .then((response: AxiosResponse<IndexResponse<JuridicalPerson>>): GetIndexJuridicalPersonsSuccess => {
          return dispatch(getIndexJuridicalPersonsSuccess(response.data.content));
        }).catch((e: { response: { data: { error: {} } } }): GetIndexJuridicalPersonsFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getIndexJuridicalPersonsFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/juridical-person/index/GetIndexJuridicalPersons.actions.tsx